/** O endereço da Anomalia Frota e a aba que mora nele (Samuel, 04/11/2026). Até ali a
 *  tela era a Anomalia Noturna, em `/logistica/frota-leve/anomalias`, só da frota leve. */
import { TIPOS_DE_FROTA, type TipoDeFrota } from './tipos'

export const ROTA_DA_ANOMALIA_FROTA = '/logistica/anomalia-frota'
export const ROTA_DA_ANOMALIA_NOTURNA = '/logistica/frota-leve/anomalias'

/** A aba da URL; sem ela, ou com uma desconhecida, a primeira, a Frota Pesada. */
export function abaDaUrl(valor: string | null): TipoDeFrota {
  return TIPOS_DE_FROTA.find((t) => t === valor) ?? 'pesada'
}
